import Service, { getCallApiFunction } from '../service'

// 會員偏好分類（shop-api /v1/member/category-preference，需登入）：給「為你推薦」用

// 可選分類：第一層分組，children 是可勾選的第二層（只列有可購買商品的）
export type CategoryPreferenceOption = {
  id: number
  name: string
  // 第二層才有：該分類目前最熱門商品的主圖，沒有可推薦商品時沒有
  image?: string
  children?: CategoryPreferenceOption[]
}

export type CategoryPreferenceType = {
  categoryIds: number[]
  // 是否回答過（含略過）；false 時首頁會跳選擇視窗
  answered: boolean
  updatedAt: string | null
  options: CategoryPreferenceOption[]
}

class FetchCategoryPreferenceApi extends Service {
  constructor() {
    super()
    this.name = 'FETCH_CATEGORY_PREFERENCE'
    this.config = {
      url: '/v1/member/category-preference',
      method: 'GET',
    }
  }
}

// 整筆覆寫；空陣列代表略過（之後不再主動詢問）
class UpdateCategoryPreferenceApi extends Service {
  constructor(categoryIds: number[]) {
    super()
    this.name = 'UPDATE_CATEGORY_PREFERENCE'
    this.config = {
      url: '/v1/member/category-preference',
      method: 'PUT',
      data: { categoryIds },
    }
  }
}

export const fetchCategoryPreference = (): Promise<CategoryPreferenceType> => getCallApiFunction(new FetchCategoryPreferenceApi())

export const updateCategoryPreference = (categoryIds: number[]): Promise<CategoryPreferenceType> =>
  getCallApiFunction(new UpdateCategoryPreferenceApi(categoryIds))
